import { useEffect, useState } from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

type Props = {
  src: string;
  autoplay?: boolean;
  loop?: boolean;
  onComplete?: () => void;
};

export const DotLottie = ({
  src,
  autoplay = true,
  loop = false,
  ...props
}: Props) => {
  const [dotLottie, setDotLottie] = useState(null);

  useEffect(() => {
    // This function will be called when the animation starts playing.
    function onPlay() {
      console.log("Animation start playing");
    }

    // This function will be called when the animation is paused.
    function onPause() {
      console.log("Animation paused");
    }

    // This function will be called when the animation is completed.
    function onComplete() {
      console.log("Animation completed");
      props.onComplete?.();
    }

    function onFrameChange({ currentFrame }) {
      // console.log("Current frame: ", currentFrame);
    }

    // Listen to events emitted by the DotLottie instance when it is available.
    if (dotLottie) {
      dotLottie.addEventListener("play", onPlay);
      dotLottie.addEventListener("pause", onPause);
      dotLottie.addEventListener("complete", onComplete);
      dotLottie.addEventListener("frame", onFrameChange);
    }

    return () => {
      // Remove event listeners when the component is unmounted.
      if (dotLottie) {
        dotLottie.addEventListener("play", onPlay);
        dotLottie.addEventListener("pause", onPause);
        dotLottie.addEventListener("complete", onComplete);
        dotLottie.addEventListener("frame", onFrameChange);
      }
    };
  }, [dotLottie]);

  const dotLottieRefCallback = (dotLottie: any) => setDotLottie(dotLottie);

  return (
    <DotLottieReact
      {...{ src, autoplay, loop }}
      dotLottieRefCallback={dotLottieRefCallback}
    />
  );
};
